import React from "react";
import { useTranslation } from "react-i18next";

// SVG Icons (Heroicons style)
// const PhoneIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     className="h-5 w-5 text-indigo-400"
//     fill="none"
//     viewBox="0 0 24 24"
//     stroke="currentColor"
//     strokeWidth={2}
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.308 1.154a11.034 11.034 0 005.378 5.378l1.154-2.308a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//     />
//   </svg>
// );

const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 text-indigo-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

// const LocationIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     className="h-5 w-5 text-indigo-400"
//     fill="none"
//     viewBox="0 0 24 24"
//     stroke="currentColor"
//     strokeWidth={2}
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//     />
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//     />
//   </svg>
// );

const LinkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 text-indigo-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
    />
  </svg>
);
// The new Contact Information Block
const ContactInfoBlock = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-12 bg-slate-800 p-8 rounded-xl shadow-xl text-gray-200 h-full w-full xl:w-1/4">
      <h3 className="text-3xl font-bold mb-8 text-white">{t("footer.contactUs", "Direct Contact")}</h3>
      <ul className="space-y-6">
        {/* <li className="flex items-start">
          <span className="flex-shrink-0 w-7 h-7 bg-slate-700 rounded-full flex items-center justify-center mt-1">
            <PhoneIcon />
          </span>
          <div className="ml-4">
            <p className="font-semibold text-lg text-white">Call Us</p>
            <a
              //   href="tel:+1234567890"
              className="text-indigo-400 hover:text-indigo-300 transition-colors duration-150"
            >
              Not available
            </a>
            <p className="text-sm text-gray-400">Mon - Fri, 9am - 6pm</p>
          </div>
        </li> */}
        <li className="flex items-start">
          <span className="flex-shrink-0 w-7 h-7 bg-slate-700 rounded-full flex items-center justify-center mt-1">
            <EmailIcon />
          </span>
          <div className="ml-4">
            <p className="font-semibold text-lg text-white">{t("footer.emailUs", "Email Us")}</p>
            <a
              href="mailto:livethewill@gmail.com"
              className="text-indigo-400 hover:text-indigo-300 transition-colors duration-150"
            >
              livethewill@gmail.com
            </a>
            <p className="text-sm text-gray-400">{t("footer.emailResponse", "We reply within 24 hours")}</p>
          </div>
        </li>
        {/* <li className="flex items-start">
          <span className="flex-shrink-0 w-7 h-7 bg-slate-700 rounded-full flex items-center justify-center mt-1">
            <LocationIcon />
          </span>
          <div className="ml-4">
            <p className="font-semibold text-lg text-white">Management</p>
            <p>LiveTheWill Music Group</p>
            <p>123 Rock Street, Music City, USA 45678</p>{" "}
          </div>
        </li>
         */}
        <li className="flex items-start">
          <span className="flex-shrink-0 w-7 h-7 bg-slate-700 rounded-full flex items-center justify-center mt-1">
            <LinkIcon />
          </span>
          <div className="ml-4">
            <p className="font-semibold text-lg text-white">{t("footer.followUs", "Follow Us")}</p>
            <div className="flex space-x-4 mt-2">
              <a
                href="https://www.instagram.com/livethewill"
                className="text-indigo-400 hover:text-indigo-300 transition-colors duration-150"
              >
                Instagram
              </a>
              <a
                href="https://www.youtube.com/@livethewill7257"
                className="text-indigo-400 hover:text-indigo-300 transition-colors duration-150"
              >
                YouTube
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};
export default ContactInfoBlock;
